import * as turf from '@turf/turf'

/**
 * 基準線の基底クラス
 */
export default class RefLineBase {
  static get UNIT() {
    return { units: 'meters' }
  }

  constructor(refLineGeoJson) {
    this.points = { east: null, west: null }
    this.refLineGeoJson = refLineGeoJson
    this.startPoint = undefined
    this.endPoint = undefined
    this.center = [0, 0]
    this.boundingBox = undefined
  }

  get startPointCoordinates() {
    return turf.getCoord(this.startPoint)
  }

  get endPointCoordinates() {
    return turf.getCoord(this.endPoint)
  }

  get startPointGeoJson() {
    return turf.point(turf.getCoord(this.startPoint))
  }

  get endPointGeoJson() {
    return turf.point(turf.getCoord(this.endPoint))
  }

  get redMultiLineGeoJson() {
    return undefined
  }

  get blueMultiLineGeoJson() {
    return undefined
  }

  toMultiLineString(lineStringArray) {
    const coordinates = lineStringArray.map(line => {
      return turf.getCoords(line)
    })
    return turf.multiLineString(coordinates)
  }

  toLineString(point1, point2) {
    const c1 = turf.getCoord(point1)
    const c2 = turf.getCoord(point2)
    return turf.lineString([c1, c2])
  }

  _appendPointsOrLine(lines, pointOrLineArray, options = { filter: 'even', type: 'point' }) {
    for (let i = 0; i < pointOrLineArray.length; i++) {
      let condition = false
      if (options.filter === 'even') {
        condition = i % 2 === 0
      } else if (options.filter === 'odd') {
        condition = i % 2 !== 0
      }
      if (condition) {
        if (options.type === 'point') {
          const point = pointOrLineArray[i]
          lines.push(this.toLineString(point.west, point.east))
        } else if (options.type === 'line') {
          const appendLine = pointOrLineArray[i]
          lines.push(appendLine)
        }
      }
    }
  }
}
